import { render, staticRenderFns } from "./AdditionalCriterionList.vue?vue&type=template&id=5babd412&"
import script from "./AdditionalCriterionList.vue?vue&type=script&lang=js&"
export * from "./AdditionalCriterionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports